<app-loading-spinner *ngIf="isLoading" />


<div *ngIf="!isLoading">

    <div class="max-[1024px]:flex-wrap flex flex-row items-center gap-5 font-semibold text[#424242] dark:text-white mb-4 mr-5 ml-0 cursor-pointer">
    <p (click)="goBack()" >Product Shortage</p>
    <p>Product Shortage History</p>
</div>


  <div class="max-[640px]:px-4 w-full min-w-0 min-h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg overflow-x-auto">
    <div class="flex flex-row flex-nowrap max-[1024px]:flex-wrap items-center justify-between gap-8 ">

        <p class="min-w-0 dark:text-white font-500">Product Shortage History</p>

        <div class="flex flex-row flex-nowrap max-[1024px]:flex-wrap max-[1024px]:basis-full max-[1024px]:justify-start items-center justify-end gap-8 flex-1 min-w-0">
            <i class="shrink-0 fa-solid fa-list text-lg text-[#4A4A4A] dark:text-white"></i>

            <p class="shrink-0 whitespace-nowrap text-[#4A4A4A] dark:text-white">Filter By</p>

            <div class="w-36 shrink-0 max-[640px]:w-full">
            <app-custom-datepicker
            [placeholder]="'Date'"
              [selectedDate]="selectedDate"
              (dateChange)="onDateChange($event)"
            ></app-custom-datepicker>
        </div>

            <div class="flex-1 min-w-32 max-w-96 max-[640px]:basis-full max-[640px]:max-w-none max-[1024px]:mr-0 [&_button]:shrink-0 flex mr-5 items-center rounded-full px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#292929]">
                <input type="text" placeholder="Search By Product & Assig..." [(ngModel)]="searchText"
                    class="bg-transparent outline-none w-full min-w-0 text-textLight dark:text-textDark"
                    (keyup.enter)="onSearch()" (keyup.esc)="offSearch()" />
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                    (click)="onSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                    </svg>
                </button>
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="offSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>

    </div>


    <div *ngIf="hasData"
        class="max-[1024px]:mr-0 min-w-0 overflow-x-auto mt-8 mr-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
        <table class="w-full min-w-max divide-y-2 overflow-hidden">
            <thead class=" text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021] cursor-default">
                <tr>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">No</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Image</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Product Name</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-center font-medium">Shortage (kg)</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Price per kg (Rs.)</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Assignee</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-center font-medium">Purchased (kg)</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-center font-medium">Purchase Price Per kg (Rs.)</th>
                    <th class="px-6 py-3 whitespace-nowrap text-[#4B5563] text-left font-medium">Purchase Time</th>
                </tr>
            </thead>
            <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F] cursor-default">
                <tr *ngFor="let item of itemsArr; let i = index">
                    <td class="px-6 py-4 text-[#000000] font-500 dark:text-gray-300">
                        {{ i + 1 | number:'2.0' }}
                    </td>
                <td class="px-6 py-4 whitespace-nowrap text-[#000000] font-500 dark:text-gray-300"> <img [src]="item.image" alt="Image"
                        class="w-10 h-10 rounded-full object-cover" /> </td>
                <td class="px-6 py-4  whitespace-nowrap text-[#000000] font-500 dark:text-gray-300">{{item.displayName}}</td>
                <td class="px-6 py-4 whitespace-nowrap text-center">
  <div class="inline-flex items-center justify-center rounded-md bg-[#FEF7EF] px-3 py-1">
    <span class="text-[#9D6C00] font-semibold">
      {{ item.qty | number:'1.3-3' }}
    </span>
  </div>
</td>
            <td class="px-6 py-4  whitespace-nowrap text-[#9D6C00] text-left font-600 dark:text-[#9D6C00]">{{item.price | number:'1.2-2'}}</td>
                <td class="px-6 py-4 text-[#000000] text-left font-500 dark:text-gray-300">{{item.empId || "----"}}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-center">
  <div class="inline-flex items-center justify-center rounded-md bg-[#EDF5FC] px-3 py-1 min-w-[48px]">
    <span class="text-[#415CFF] font-semibold">
      {{ item.prchQty ? (item.prchQty | number:'1.3-3') : '----' }}
    </span>
  </div>
</td>
                <td class="px-6 py-4 whitespace-nowrap text-[#415CFF] text-left font-600 dark:text-gray-300">{{item.prchPrice ? (item.prchPrice | number:'1.2-2') :
                    "----"}}</td>
                <td class="px-6 py-4 whitespace-nowrap text-[#000000] text-left font-500 dark:text-gray-300">{{item.createdAt | date:
                    'hh:mm a on yyyy/MM/dd'}}</td>
                </tr>
            </tbody>
        </table>

    </div>

    <div *ngIf="!hasData" class="flex flex-col items-center w-full h-screen max-[640px]:px-2 max-[640px]:text-center px-10 py-7 mt-6 ">
        <p class="text-[#494949] my-6 dark:text-textDark">--No Data Available--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20" />
    </div>

  </div>
</div>
